import { Button, Divider, Layout, Spin } from 'antd'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import BoxFilter from './BoxFilter'
import BoxList from './BoxList'
import { PlusOutlined } from '@ant-design/icons'
import { useForm } from 'antd/es/form/Form'
import { postMultipart } from '../../Common/api'
import { Color } from '../../Common/Color'
import BoxCards from './BoxCards'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import BoxCreationForm from './BoxCreationForm'
import CustModal from '../../Common/CustModal'
import GlobalContext from '../GlobalContext'

export default function BoxesPage () {
  const { data, notificationApi } = useContext(GlobalContext)
  const [filter, setFilter] = useState({ name: '', zip_code: '', owner_id: '', level: 'all', online: 'all' })
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()

  const screens = useBreakpoint()

  const formatBoxes = (boxes, owners, events) => {
    return boxes.map((box) => {
      return {
        ...box,
        owner: owners?.find(owner => owner.id === box.owner_id),
        unresolved_events: events?.filter(event => event.box_id === box.id)
      }
    })
  }

  const postBox = async (params) => {
    setLoading(true)
    await postMultipart({
      url: 'admin/boxes',
      params,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: () => {
        setModalVisible(false)
        setLoading(false)
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  const onChangeFilter = (filter) => {
    setFilter(filter)
  }

  const openAddModal = () => {
    form.resetFields()
    form.setFieldValue('active', false)
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    await postBox(values)
  }

  const boxes = formatBoxes(data.boxes, data.owners, data.unresolved_events)

  const filteredBoxes = boxes.filter((box) => {
    return box.name.toLowerCase().includes(filter.name.toLowerCase()) &&
      box.zip_code.includes(filter.zip_code) &&
      box.owner_id.includes(filter.owner_id) &&
      (filter.level === 'all' || box.level.includes(filter.level)) &&
      (filter.online === 'all' || (box.is_online === filter.online))
  })

  const hasProblem = (box) => (box.has_problem)
  const boxesWithError = filteredBoxes.filter(hasProblem)
  const boxesWithoutError = filteredBoxes.filter((box) => !hasProblem(box))
  const [collapsed, setCollapsed] = useState(true)

  useEffect(() => {
    setCollapsed(boxesWithError.length === 0)
  }, [boxesWithError])

  const multipleTables = (dataSourceError, dataSource) => {
    return (
      <>
        <BoxList boxes={dataSourceError} height={155}/>
        <Divider style={{ margin: 0 }}/>
        <BoxList boxes={dataSource} height={530}/>
      </>
    )
  }

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{boxes.length}</b> {t('Admin.BoxesPage.title')}</div>
          {!screens.xs && <BoxFilter owners={data.owners} filter={filter} onChangeFilter={onChangeFilter} /> }
          <Button onClick={openAddModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        { !screens.xs && !collapsed && multipleTables(boxesWithError, boxesWithoutError) }
        { !screens.xs && collapsed && <BoxList boxes={boxesWithoutError} height={700} /> }
        { screens.xs && <BoxCards boxes={filteredBoxes} /> }
        <CustModal
          open={modalVisible}
          setOpen={setModalVisible}
          width="1000px"
          title={t('Admin.BoxesPage.addBoxTitle')}
          onOk={form.submit}
          confirmLoading={loading}
        >
          <Spin spinning={loading}>
            <BoxCreationForm form={form} onFinish={onAdd} owners={data.owners} />
          </Spin>
        </CustModal>
      </Spin>
    </Layout>
  )
}
